export default {

    state: {
        currentStep: 1,
        form: {
            currendOrderId: null,
            customerId: null,
            customer_name: null,
            customer_email: null,
            reason: null,
            reasonString: null,
            solveWish: null,
            text: {
                problemDiscription: false,
                additionalText: false
            },
            images: {
                image1: false,
                image2: false,
                image3: false,
                image4: false,
                image5: false,
                image6: false
            }
        }
    },

    getters: {

        getCurrentStep: state => state.currentStep,

        getForm: state => state.form,

        getReason: state => state.form.reason,

        getSolveWish: state => state.form.solveWish,

        getCurrentOrderId: state => state.form.currendOrderId
    },

    mutations: {

        incrementStep: (state) => state.currentStep++,

        setCustomerId: (state, value) => state.form.customerId = value,

        setCustomerName: (state, value) => state.form.customer_name = value,

        setCustomerMail: (state, value) => state.form.customer_email = value,

        setImage: (state, query) => state.form.images[query.name] = query.value,

        setText: (state, query) => state.form.text[query.name] = query.value,

        setReason: (state, value) => state.form.reason = value,

        setReasonString: (state, value) => state.form.reasonString = value,

        setSolveWish: (state, value) => state.form.solveWish = value,

        setCurrentOrderIs: (state, value) => state.form.currendOrderId = value,


        resetWizard(state) {
            state.currentStep = 1
            state.form = Object.assign(state.form, {
                currendOrderId: null,
                customerId: null,
                customer_name: null,
                customer_email: null,
                reason: null,
                reasonString: null,
                solveWish: null,
                text: {
                    problemDiscription: false,
                    additionalText: false
                },
                images: {
                    image1: false,
                    image2: false,
                    image3: false,
                    image4: false,
                    image5: false,
                    image6: false
                }
            })
        }
    }
}